module.exports = __webpack_public_path__ + "img/zhangsong.3898225a.jpg";